<template>
  <div class="mt-4">
    <v-row justify="center" v-if="getUser != null">
      <v-col cols="12" md="10" lg="8">
        <v-sheet outlined rounded class="pa-4">
          <div class="d-flex justify-space-between">
            <div class="basic--text">{{ '0%' }}</div>
            <div class="basic--text">
              {{
                  getUser != null ? getUser.admission.applicationType.name : ""
              }}
            </div>
            <div class="basic--text">100%</div>
          </div>
          <v-progress-linear :value="step * quotient" stream height="10" rounded class="my-4"></v-progress-linear>
        </v-sheet>

        <v-card class="mt-4" elevation="0" outlined>
          <v-card-text class="pt-4">
            <personal-details v-on:success="increment" v-if="step === 1"></personal-details>
            <contact-details v-on:success="increment" v-on:back="decrement" v-if="step === 2"></contact-details>
            <next-of-kin-details v-on:success="increment" v-on:back="decrement" v-if="step === 3"></next-of-kin-details>
            <nysc-details v-on:success="increment" v-on:back="decrement" v-if="step === 4"></nysc-details>
            <qualifications v-on:success="increment" v-on:back="decrement" v-if="step === 5"></qualifications>
            <programme-and-passport v-on:success="increment" v-on:back="decrement" v-if="step === 6">
            </programme-and-passport>
            <application-fee v-on:success="increment" v-on:back="decrement" v-if="step === 7"></application-fee>
            <screening-fee v-on:success="increment" v-on:back="decrement" v-if="step === 8"></screening-fee>
            <u-t-m-e-details v-on:success="increment" v-on:back="decrement" v-if="step === 9"></u-t-m-e-details>
            <s-s-c-e-details v-on:success="increment" v-on:back="decrement" v-if="step === 10"></s-s-c-e-details>
            <template v-if="step === 11">
              <scratch-card v-on:success="increment" v-on:back="decrement" v-if="!manualScratchCard && hasAutoScratchCards"></scratch-card>
              <scratch-card-manual v-on:success="increment" v-on:back="decrement" v-else></scratch-card-manual>
            </template>

            <application-complete v-if="step === 12"></application-complete>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="d-flex flex-column" style="height: 100%" v-else>
      <div class="mx-auto my-auto">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </div>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
      v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import PersonalDetails from "../../../components/PersonalDetails";
import ContactDetails from "../../../components/ContactDetails";
import NextOfKinDetails from "../../../components/NextOfKinDetails";
import UTMEDetails from "../../../components/UTMEDetails";
import SSCEDetails from "../../../components/SSCEDetails";
import Qualifications from "../../../components/Qualifications";
import NyscDetails from "../../../components/NyscDetails";
import ProgrammeAndPassport from "../../../components/ProgrammeAndPassport";
import { mapActions, mapGetters } from "vuex";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ApplicationFee from "../../../components/ApplicationFee";
import ScreeningFee from "../../../components/ScreeningFee";
import LoginUtil from "../../../../login/LoginUtil";
import ApplicationComplete from "../../../components/ApplicationComplete";
import StudentStatus from "@/shared/StudentStatus";
import ScratchCard from "@/application/components/ScratchCard";
import ScratchCardManual from "@/application/components/ScratchCardManual";



export default {
  name: "Application",
  components: {
    ScratchCardManual,
    ScratchCard,
    ApplicationComplete,
    ProgrammeAndPassport,
    ScreeningFee,
    ApplicationFee,
    MessageBox,
    LoadingDialog,
    SSCEDetails,
    UTMEDetails,
    NextOfKinDetails,
    ContactDetails,
    PersonalDetails,
    Qualifications,
    // eslint-disable-next-line vue/no-unused-components
    NyscDetails,
  },


  data: () => ({
    step: 0,
    finalStep: 12,
    quotient: 100 / 12,
    steps: [],
    messageShow: false,
    canIncrement: true,
    loading: false,
    message: "",
    messageType: "",
    appType: null,
    stepsLength: -2, // set to negative 2 to avoid calling computeSteps() on every user update
  }),

  methods: {
    increment: function () {
      this.step = this.steps[++this.stepsLength];
    },

    decrement: function () {
      this.step = this.steps[--this.stepsLength];
    },

    hasStep(st) {
      for (let v = 0; v < this.steps.length; v++) {
        if (this.steps[v] === st)
          return true
      }

      return false
    },

    requireQualification(){
      if (this.getUser != null) {
        let ap = this.getUser.admission.applicationType
        return ap.qualificationDetailsEnabled && (this.getUser.modeOfEntry == null || this.getUser.modeOfEntry.requireScreeningDocuments)
      }

      return false;
    },

    computeSteps() {
      if (this.getUser != null) {

        let ap = this.getUser.admission.applicationType
        this.appType = ap;
        // compute and keep track of steps
        // first step is personal details
        // TODO: make generic
        let nyscStep = 0;
        this.steps = []
        this.steps.push(1)
        this.stepsLength = 0
        // reset
        this.canIncrement = true
        // if first step is complete
        if (this.getInformation != null && this.getInformation.lga != null) {
          this.stepsLength++
        } else{
          this.canIncrement = false
        }
        // if contact details enabled
        if (ap.contactDetailsEnabled) {
          this.steps.push(2)
          // contact
          if (this.getInformation != null && this.getInformation.contactLga != null && this.canIncrement) {
            this.stepsLength++
          }else{
            this.canIncrement = false
          }
        }

        // if next of kin details enabled
        if (ap.nextOfKinDetailsEnabled) {
          this.steps.push(3)
          // next of kin
          if (this.getInformation != null && this.getInformation.nextOfKinPhone != null && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if NYSC details enabled
        if (ap.nyscDetailsEnabled) {
          this.steps.push(4)
          // nysc
          if (this.getNYSCDetails != null && this.getNYSCDetails.documentPath && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if Qualifications details enabled
        if (ap.qualificationDetailsEnabled && (this.getUser.modeOfEntry == null || this.getUser.modeOfEntry.requireScreeningDocuments)) {
          this.steps.push(5)

          if (this.getQualificationCertificate.length > 0 && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // programme selection step
        this.steps.push(6)
        // user has
        if (this.getUser.programme != null && this.canIncrement) {
          this.stepsLength++
        } else{
          this.canIncrement = false
        }

        // if application fee enabled
        if (ap.applicationFee > 0.1) {
          this.steps.push(7)
          //application complete
          if (StudentStatus[this.getUser.studentStatus].value >= StudentStatus.APPLICATION_COMPLETE.value && this.canIncrement) {
            this.stepsLength++
            // else the user will remain in application fee payment screen
          } else{
            this.canIncrement = false
          }
        }

        // if screening enabled
        if (ap.screeningFee > 0.1) {
          this.steps.push(8)
          //screening complete
          if (StudentStatus[this.getUser.studentStatus].value > StudentStatus.SCREENING_PAYMENT_PENDING.value && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if UTME details enabled
        if (ap.utmeDetailsEnabled && (this.getUser.modeOfEntry == null || this.getUser.modeOfEntry.requireUtmeScores)) {
          this.steps.push(9)
          if (this.getUTMEDetails != null && StudentStatus[this.getUser.studentStatus].value > StudentStatus.SCREENING_PAYMENT_PENDING.value && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if SSCE details enabled
        if (ap.ssceDetailsEnabled) {
          this.steps.push(10)
          if (this.getSSCEDetails.length > 0) {
            // check if scratch card is required
            if (ap.scratchCardDetailsEnabled) {
              this.steps.push(11)
              // if scratch card has been purchased
              if((this.getScratchCards.length === this.getSSCEDetails.length && this.canIncrement) || (!this.manualScratchCard && !this.hasAutoScratchCards)){
                this.stepsLength = this.stepsLength + 2
              } else{
                if(this.canIncrement)
                  this.stepsLength++
                else
                  this.canIncrement = false
              }
            } else{
              if(this.canIncrement)
                this.stepsLength = this.stepsLength + 2
              else
                this.canIncrement = false
            }
          }
        }

        // incase scratch card was not included
        if(ap.scratchCardDetailsEnabled && !this.steps.includes(11, 0)){
          this.steps.push(11)
          if((this.getSSCEDetails.length > 0 && this.getScratchCards.length === this.getSSCEDetails.length && this.canIncrement) || (!this.manualScratchCard && !this.hasAutoScratchCards)){
            this.stepsLength = this.stepsLength + 2
          }
        }

        // push application complete
        this.steps.push(this.finalStep)

        // assign step
        this.step = this.steps[this.stepsLength];
        let urlParams = this.$route.query?.step
        if(urlParams && typeof Number.isInteger(urlParams)){
          //this.step = urlParams
        }
      }
    },

    ...mapActions(["getInitialData"]),
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },

    manualScratchCard: function(){
      // console.log(this.getSSCEDetails)
      // console.log(this.appType)
      return this.appType?.manualScratchCard || this.appType?.collectNonAutomaticOrgs
    },

    appType: function(){
      return this.getUser?.admission?.applicationType
    },

    hasAutoScratchCards: function(){
      return this.appType?.autoScratchCards?.length > 0 &&
        (this.getSSCEDetails?.filter(e => !e.manualScratchCard && !e.scratchCardPin)?.length ?? 0) > 0
    },

    ...mapGetters(["getUser", 'getInformation', 'getNYSCDetails', 'getQualificationCertificate', 'getUTMEDetails', 'getSSCEDetails', "getScratchCards"]),
  },

  watch: {
    getUser: function (val) {
      if (val) {
        // compute steps
        if (this.stepsLength < 0) {
          this.computeSteps()
          if (StudentStatus[this.getUser.studentStatus].value >= StudentStatus.SCREENING_PENDING.value) {
            if((this.requireQualification() && this.getQualificationCertificate != null && this.getQualificationCertificate.length > 0) ||
                !this.requireQualification()){
              this.step = this.finalStep;
              return;
            }
          }
          this.step = this.steps[this.stepsLength]
        }
      }
    },
  },

  created() {
    if (window.canReload) {
      window.canReload = false;
      window.location.reload();
      return;
    }
    if (!LoginUtil.checkAuth()) {
      // not logged in
      this.$router.push("/");
    }
    if (this.getUser != null) {
      if (StudentStatus[this.getUser.studentStatus].value >= StudentStatus.SCREENING_PENDING.value) {
        if((this.requireQualification() && this.getQualificationCertificate != null && this.getQualificationCertificate.length > 0) ||
            !this.requireQualification()){
          this.step = this.finalStep;
          return;
        }
      }
    }

    this.computeSteps()
  },
};
</script>

